<script>
import TopActiveYokohama from './TopActiveYokohama.vue'
import TopActiveOsaka from './TopActiveOsaka.vue'
import TopPageActivitiesTableToda from '@/components/layout/topToda/TopPageActivitiesTableToda'
import TopPageActivitiesTable from '@/components/layout/top/TopPageActivitiesTable'
import { injectFromLocation } from '@/helpers/Provider.js'
export default {
  extends: injectFromLocation(TopPageActivitiesTable, [
    TopActiveYokohama,
    TopActiveOsaka,
    TopPageActivitiesTableToda,
  ]),
  name: 'TopActiveProvider',
  setup() {
    return {
      ...injectFromLocation(TopPageActivitiesTable, [
        TopActiveYokohama,
        TopActiveOsaka,
        TopPageActivitiesTableToda,
      ]).setup(),
    }
  },
}
</script>
